export default "__VITE_ASSET__7642a189__"